// components/GlobalToast.js
import { useEffect, useState, useRef } from "react";
import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import eventBus from "../services/eventBus";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { FaCheckCircle, FaInfoCircle, FaExclamationTriangle, FaTimesCircle } from "react-icons/fa";

const TOAST_ICONS = {
    success: <FaCheckCircle className="text-success me-2" />,
    warning: <FaExclamationTriangle className="text-warning me-2" />,
    danger:  <FaTimesCircle className="text-danger me-2" />,
    info:    <FaInfoCircle className="text-info me-2" />,
};

function GlobalToast() {
    const [toasts, setToasts] = useState([]);
    const nodeRefs = useRef(new Map())
    useEffect(() => {
        const handler = (payload) => {
            setToasts((prev) => [
                ...prev,
                { id: Date.now() + Math.random(), ...payload }, // unique id
            ]);
        };

        console.log('in the global toast use effect')

        eventBus.on("toast", handler);
        return () => eventBus.off("toast", handler);
    }, []);

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    };

    return (
        <ToastContainer position="bottom-start" className="p-3" style={{ position: "fixed" }}>
            <TransitionGroup>
                {toasts.map((toast) => {
                    if (!nodeRefs.current.has(toast.id)) {
                        nodeRefs.current.set(toast.id, React.createRef());
                    }
                    const nodeRef = nodeRefs.current.get(toast.id);
                    return (
                        <CSSTransition
                            key={toast.id}
                            nodeRef={nodeRef}
                            timeout={500}
                            classNames="toast-fade"
                            unmountOnExit
                        >
                            <Toast
                                ref={nodeRef}
                                key={toast.id}
                                bg={toast.type || "light"}
                                onClose={() => removeToast(toast.id)}
                                className="mb-3"
                                show={true}
                                delay={7000}
                                autohide
                                animation={true}
                            >
                                <Toast.Header closeButton>
                                    {TOAST_ICONS[toast.type] ?? TOAST_ICONS.info}
                                    <strong className="me-auto">Notification</strong>
                                </Toast.Header>
                                <Toast.Body style={{ backgroundColor: '#fff' }}>{toast.message}</Toast.Body>
                            </Toast>
                        </CSSTransition>
                    )
                })}
            </TransitionGroup>
        </ToastContainer>
    );
}

export default GlobalToast;
